import { APP_URL } from "Constants";
import {REACT_APP_APP_URL} from "Constants"
import StpiLogoSVG from "assets/img/stpi/STPI.webp";
import useScreenSize from "common/hooks/useScreenSize";
import { FaChevronRight } from "react-icons/fa6";
import { Link, NavLink } from "react-router-dom";
import { HashLink, NavHashLink } from "react-router-hash-link";

const Navbar = () => {
  const screenSize = useScreenSize();

  return (
    <nav className="app-navbar navbar navbar-expand-xl bg-white navbar-light shadow p-0">
      <Link
        to="/#home"
        className="navbar-brand d-flex align-items-center px-2 px-xl-5 me-2"
      >
        <div className="m-0 text-primary d-flex align-items-baseline navbar-title">
          <img
            src={StpiLogoSVG}
            alt="STPI"
            width={screenSize.isMobile ? 60 : 80}
          />
          <h2 className="fs-6 text-primary navbar-title">Workspace </h2>
        </div>
      </Link>
      <button
        type="button"
        className="navbar-toggler me-2"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto p-4 p-xl-0">
          <NavHashLink smooth to="/#" className="nav-item nav-link">
            Home
          </NavHashLink>          
          <NavLink to="/centers" className="nav-item nav-link">
            Discovery
          </NavLink>
          {/* New Link */}
          <NavLink to="/facility-booking" className="nav-item nav-link">
            Facility Booking
          </NavLink>
          {/* ---- */}
          <NavLink to="/application-status" className="nav-item nav-link">
            Application Tracking
          </NavLink>
          <HashLink to="/#contact" className="nav-item nav-link">
            Enquiry
          </HashLink>         
          <a
            // href="https://localhost/stpi-test-server/unit/jindex.php"
            href={`${APP_URL}/jindex.php`}
            className="nav-item nav-link"
            target="_blank"
            rel="noreferrer"
          >
            Login
          </a>
          <NavLink
            to="/apply"
            className={`nav-item nav-link d-block d-xl-none bg-primary text-white text-center`}
          >
            Apply Now
          </NavLink>
        </div>
        <NavLink
          to="/apply"
          className={`btn btn-primary py-4 px-xl-5 d-none d-xl-block nav-item nav-link`}
        >
          Apply Now <FaChevronRight className="ms-3" />
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
